import { FETCH_COMPANY, UPDATE_COMPANY, SET_COMPANY } from "../actions/types";

export default function rootReducer(state = {}, action) {
  // console.log({action});
  switch (action.type) {
    case FETCH_COMPANY:
      if (!action.company) return state;
      return { ...action.company };
    case SET_COMPANY:
      if (!action.company) return state;
      return { ...action.company };
    case UPDATE_COMPANY:
      if (!action.company) return state;
      return { ...state, ...action.company };
    default:
      return state;
  }
}
